import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

import { RepresentativeAddressDataForm } from './representative-address-data-form';

export const PostalAddressForm = ({
  fieldsName,
}: {
  fieldsName?: {
    postCode: string;
    city: string;
    street: string;
    country: string;
  };
}) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ marginTop: '16px', marginLeft: { xs: '10px', lg: '30px' } }}>
      <Typography sx={{ marginBottom: '16px' }}>
        {t('welcomePage.loanApplicationPossible.liberis.beneficientData.mailingAddressLabel')}
      </Typography>
      <Box sx={{ marginTop: '10px', paddingX: { xs: '10px', lg: '30px' } }}>
        <RepresentativeAddressDataForm
          withSummary={false}
          containerSettings={{
            rowSpacing: 1.5,
          }}
          fieldsName={fieldsName}
        />
      </Box>
    </Box>
  );
};
